import log from "loglevel";

type LogLevel = "trace" | "debug" | "info" | "warn" | "error" | "silent" | null;

export const logLevel: LogLevel = "debug";

export const initLogger = () => {
    log.setLevel(logLevel, false);
};
